import log from 'util/logger'
import waitForValue from 'util/wait-for-value'

const SVG_CONTAINER_ID = 'tt-svg-icons'

export default function (svgContent: string): void {
  const div = document.createElement('div')
  div.id = SVG_CONTAINER_ID
  div.style.display = 'none'
  div.style.width = '0'
  div.style.height = '0'
  waitForValue(() => document.body).then(() => {
    document.body.insertBefore(div, document.body.childNodes[0])
    div.innerHTML = svgContent
  }).catch(() => {
    log.warn('Error inserting icons')
  })
}
